(function () {
  if (window.__EIKEN_PRODGRID_INIT__) return;
  window.__EIKEN_PRODGRID_INIT__ = true;

  // Collections disparues (404) encore citées dans des articles et leurs traductions :
  // on les redirige ici plutôt que de retoucher 20 blocs × 9 langues (01/10/2026).
  var HANDLE_ALIASES = {
    "leather-duffle-bags": "leather-duffle-travel-bags",
    "canvas-backpacks": "vintage-canvas-backpacks",
    "sustainable-shoulder-bags": "sustainable-shoulder-bags-pouches"
  };

  function safeText(s) {
    return String(s || "").replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }

  function getImgAt(p, idx) {
    if (!p || !Array.isArray(p.images) || !p.images[idx]) return null;
    var f = p.images[idx];
    if (typeof f === "string") return { src: f, alt: "" };
    if (f && typeof f === "object" && f.src) return f;
    return null;
  }

  function getImgObj(p) {
    var first = getImgAt(p, 0);
    if (first) return first;
    if (p && p.image && p.image.src) return p.image;
    return null;
  }

  function isAvailable(product) {
    if (product && typeof product.available === "boolean") return product.available;
    return Array.isArray(product.variants) && product.variants.some(function (v) { return !!v.available; });
  }

  function getLocale() {
    var htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    var path = (window.location.pathname || "").toLowerCase();
    if (htmlLang.startsWith("fr") || path.indexOf("/fr/") !== -1) return "fr";
    if (htmlLang.startsWith("es") || path.indexOf("/es/") !== -1) return "es";
    if (htmlLang.startsWith("de") || path.indexOf("/de/") !== -1) return "de";
    if (htmlLang.startsWith("nl") || path.indexOf("/nl/") !== -1) return "nl";
    if (htmlLang.startsWith("it") || path.indexOf("/it/") !== -1) return "it";
    if (htmlLang.startsWith("pl") || path.indexOf("/pl/") !== -1) return "pl";
    if (htmlLang.startsWith("pt") || path.indexOf("/pt/") !== -1) return "pt";
    if (htmlLang.startsWith("sv") || path.indexOf("/sv/") !== -1) return "sv";
    return "en";
  }

  // Locales servies sous un préfixe d'URL. Une carte doit pointer vers /sv/products/…
  // sinon le clic sort le visiteur de sa langue et retombe sur la version anglaise.
  // Le préfixe sert AUSSI à l'appel products.json : sans lui l'API renvoie les titres ET
  // les handles anglais, donc des cartes anglaises menant à des pages anglaises sur une
  // page traduite. Voir loadOne().
  // Attention : pt-PT est servi sous /pt, le préfixe d'URL n'est pas l'iso_code.
  var PATH_PREFIXES = {
    fr: "/fr",
    de: "/de",
    es: "/es",
    it: "/it",
    nl: "/nl",
    pl: "/pl",
    pt: "/pt",
    sv: "/sv"
  };

  function localePrefix() {
    return PATH_PREFIXES[getLocale()] || "";
  }

  // Libellés : theme.strings (locales/*.json via theme.liquid — unification
  // 07/09/2026). Les tables 9 langues en dur ont été déplacées dans les
  // fichiers de locale ; le repli anglais est une branche morte tant que
  // theme.liquid émet les clés. NB voix suédoise : la valeur sv de
  // prodgrid_sale est « NEDSATT » (« REA » est un hard ban hors soldes).
  function themeString(key, fallback) {
    return (window.theme && window.theme.strings && window.theme.strings[key]) || fallback;
  }

  function btnLabel() {
    return themeString("eikenProdgridDiscover", "DISCOVER");
  }

  function loadingLabel() {
    return themeString("eikenProdgridLoading", "Loading products…");
  }

  function saleLabel() {
    return themeString("eikenProdgridSale", "SALE");
  }

  // Les montants de /collections/<handle>/products.json sont TOUJOURS dans la
  // devise de la boutique (EUR), quel que soit le march\u00e9 de la session : les
  // \u00e9tiqueter avec Shopify.currency.active affichait \u00ab SEK 119 \u00bb pour 119 EUR
  // (~1 300 SEK). On affiche donc l'EUR explicitement, sans arrondir les
  // centimes (l'arrondi faussait les prix sold\u00e9s non entiers).
  // 19/10/2026 : même format que la boutique (« 39,90 € ») dans toutes les langues,
  // au lieu d'Intl par langue qui donnait « €119 » en anglais, « € 119 » en néerlandais.
  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (!isFinite(n)) return "";
    return (n % 1 === 0 ? String(n) : n.toFixed(2).replace(".", ",")) + "\u00a0\u20ac";
  }

  function getPriceInfo(p) {
    // Données de la section eiken-prodgrid-data : montants déjà formatés par
    // le serveur dans la devise du marché du visiteur — aucun reformatage.
    if (p && p.price_formatted) {
      return { price: p.price_formatted, compareAt: p.compare_at_formatted || null, formatted: true };
    }
    if (!p || !Array.isArray(p.variants) || !p.variants.length) return null;
    var v = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { v = p.variants[i]; break; }
    }
    if (!v) v = p.variants[0];
    var price = v.price;
    var compareAt = v.compare_at_price;
    var hasPromo = compareAt && parseFloat(compareAt) > parseFloat(price);
    return { price: price, compareAt: hasPromo ? compareAt : null };
  }

  function pickHandle(el) {
    var h = el.getAttribute("data-json") || el.getAttribute("data-collection") || "";
    return HANDLE_ALIASES[h] || h;
  }

  // Sélection déterministe (01/10/2026) : meilleures ventes dans l'ordre, plus de
  // tirage au hasard. La mémoire des produits déjà montrés vaut pour la PAGE seulement
  // (avant : toute la visite, via sessionStorage) : chaque article repart des vraies
  // meilleures ventes, et la 2e grille d'une même collection prend les suivantes.
  var pageSeen = new Set();
  var pageHeaded = new Set();

  function productKey(p) {
    return String(p && (p.handle || p.id) || "");
  }

  // Produits pas encore montrés d'abord, puis complément avec les déjà montrés
  // (toujours dans l'ordre des ventes) quand la collection est trop courte.
  function pickProducts(available, limit) {
    var fresh = [], seen = [];
    available.forEach(function (p) {
      var key = productKey(p);
      (key && pageSeen.has(key) ? seen : fresh).push(p);
    });
    var picked = fresh.concat(seen).slice(0, limit);
    picked.forEach(function (p) {
      var key = productKey(p);
      if (key) pageSeen.add(key);
    });
    return picked;
  }

  // En-tête « titre de la collection + Voir tous les N produits », uniquement sur la
  // première grille de chaque collection dans la page.
  function buildHead(info, handle, targetBlank) {
    if (!info || !info.url || !info.title || pageHeaded.has(handle)) return "";
    pageHeaded.add(handle);
    var label = String(info.view_all || "").trim();
    label = label.charAt(0).toUpperCase() + label.slice(1);
    var target = targetBlank ? ' target="_blank" rel="noopener"' : "";
    return (
      '<div class="eiken-prodgrid__head">' +
        '<span class="eiken-prodgrid__title">' + safeText(info.title) + '</span>' +
        (label ? '<a class="eiken-prodgrid__all" href="' + safeText(info.url) + '"' + target + '>' +
          safeText(label) + ' <span aria-hidden="true">→</span></a>' : '') +
      '</div>'
    );
  }

  var CAN_HOVER = !!(window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches);

  function pad2(n) { return (n < 10 ? "0" : "") + n; }

  function buildEyebrow(p) {
    return safeText(String(p.vendor || "").toUpperCase());
  }

  function buildCard(p, targetBlank, pathPrefix, index) {
    // p.url (section) est déjà localisée par Liquid, handle traduit compris ;
    // la reconstruction préfixe+handle reste le repli products.json.
    var productUrl = p.url || (pathPrefix || "") + "/products/" + p.handle;
    var img1 = getImgAt(p, 0) || getImgObj(p);
    // 2e photo (survol) seulement pour les souris (15/10/2026) : sur telephone elle
    // ne s'affichait jamais mais se telechargeait quand meme, une par carte.
    var img2 = CAN_HOVER ? getImgAt(p, 1) : null;
    var priceInfo = getPriceInfo(p);

    var rel = targetBlank ? ' rel="noopener"' : "";
    var target = targetBlank ? "_blank" : "_self";

    var eyebrow = buildEyebrow(p) || safeText(p.vendor || "");
    var title = safeText(p.title);

    var imgHtml = "";
    if (img1) {
      imgHtml += '<img loading="lazy" src="' + img1.src + '" alt="' + safeText(img1.alt || p.title) + '">';
      if (img2) {
        imgHtml += '<img class="eiken-card__img--hover" loading="lazy" src="' + img2.src + '" alt="">';
      }
    }

    var indexHtml = '<span class="eiken-card__index"><span>N°</span>' + pad2(index + 1) + '</span>';

    var badgeHtml = priceInfo && priceInfo.compareAt
      ? '<span class="eiken-card__badge">' + saleLabel() + '</span>'
      : '';

    var priceHtml = '';
    if (priceInfo) {
      var fmt = priceInfo.formatted
        ? function (x) { return safeText(x); }
        : formatMoney;
      if (priceInfo.compareAt) {
        priceHtml = '<span class="eiken-card__price"><del>' + fmt(priceInfo.compareAt) + '</del><ins>' + fmt(priceInfo.price) + '</ins></span>';
      } else {
        priceHtml = '<span class="eiken-card__price">' + fmt(priceInfo.price) + '</span>';
      }
    }

    // Identifiants lus par le suivi GA4 select_item (eiken-menu-events.js).
    var vid = p.variant_id || "";
    if (!vid && Array.isArray(p.variants) && p.variants.length) {
      var fv = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      vid = fv.id;
    }
    var ids = p.id && vid
      ? ' data-eg-pid="' + safeText(p.id) + '" data-eg-vid="' + safeText(vid) + '"' +
        ' data-eg-name="' + title + '"' +
        (p.price != null ? ' data-eg-price="' + safeText(p.price) + '"' : '')
      : '';

    return (
      '<a class="eiken-card" href="' + productUrl + '" target="' + target + '"' + rel + ' data-eg-pos="' + (index + 1) + '"' + ids + '>' +
        '<span class="eiken-card__img">' + indexHtml + badgeHtml + imgHtml + '</span>' +
        '<span class="eiken-card__title">' +
          '<span class="eiken-card__vendor">' + eyebrow + '</span>' +
          '<span class="eiken-card__name">' + title + '</span>' +
          '<span class="eiken-card__rule"></span>' +
          priceHtml +
        '</span>' +
        '<span class="eiken-card__btn">' + btnLabel() + ' <span class="eiken-card__arrow">→</span></span>' +
      '</a>'
    );
  }

  // Squelette (15/10/2026) : des cartes vides aux dimensions finales réservent la
  // place pendant le chargement. Avant, une ligne « Chargement… » de 15 px devenait
  // un bloc de ~1 600 px et poussait tout l'article d'un coup (décalage mesuré 0,456).
  // Statique, sans scintillement : la marque reste calme.
  function skeleton(limit, handle) {
    var head = pageHeaded.has(handle) ? "" :
      '<div class="eiken-prodgrid__head" aria-hidden="true"><span class="eiken-prodgrid__title">&nbsp;</span></div>';
    var card =
      '<span class="eiken-card" aria-hidden="true">' +
        '<span class="eiken-card__img"></span>' +
        '<span class="eiken-card__title">' +
          '<span class="eiken-card__vendor">&nbsp;</span>' +
          '<span class="eiken-card__name">&nbsp;</span>' +
          '<span class="eiken-card__rule"></span>' +
          '<span class="eiken-card__price">&nbsp;</span>' +
        '</span>' +
        '<span class="eiken-card__btn" style="visibility:hidden">&nbsp;</span>' +
      '</span>';
    var cards = "";
    for (var i = 0; i < limit; i++) cards += card;
    return head + '<div class="eiken-prodgrid__grid">' + cards + '</div>';
  }

  async function loadOne(el) {
    var handle = pickHandle(el);
    if (!handle) { el.innerHTML = ""; return; }

    var limit = parseInt(el.getAttribute("data-limit") || "4", 10);
    var targetBlank = (el.getAttribute("data-target") || "_blank").toLowerCase() === "_blank";
    var pathPrefix = localePrefix();

    el.innerHTML = '<span class="visually-hidden">' + loadingLabel() + '</span>' + skeleton(Math.max(1, limit), handle);

    var fetchLimit = Math.min(limit * 5, 24);
    // Le handle de collection reste celui en anglais : il résout sous tous les préfixes,
    // alors que le handle traduit (canvas-rucksaecke) renvoie 0 produit. Vérifié sur les
    // 16 collections utilisées par le blog et les 8 préfixes de langue.
    //
    // Source primaire : Section Rendering API (sections/eiken-prodgrid-data.liquid),
    // qui rend prix/devise/arrondis/titres/URLs dans le contexte du marché du
    // visiteur. products.json (montants EUR, titres langue par défaut) ne sert
    // plus que de repli si la section manque ou échoue.
    // sort_by=best-selling : collection.products sort dans l'ordre des ventes
    // (vérifié le 01/10/2026 sur leather-backpacks, ordre différent du tri manuel).
    var sectionUrl = pathPrefix + "/collections/" + encodeURIComponent(handle) +
                     "?section_id=eiken-prodgrid-data&sort_by=best-selling";
    var url = pathPrefix + "/collections/" + encodeURIComponent(handle) +
              "/products.json?limit=" + fetchLimit;

    try {
      var products = null;
      var collectionInfo = null;

      try {
        var secRes = await fetch(sectionUrl, { credentials: "same-origin" });
        if (secRes.ok) {
          var secHtml = await secRes.text();
          var m = secHtml.match(/<script type="application\/json" data-eiken-prodgrid-data>([\s\S]*?)<\/script>/);
          if (m) {
            var parsed = JSON.parse(m[1]);
            if (parsed && Array.isArray(parsed.products) && parsed.products.length) {
              products = parsed.products;
              collectionInfo = parsed.collection || null;
            }
          }
        }
      } catch (secErr) {
        // repli silencieux sur products.json
      }

      if (!products) {
        var res = await fetch(url, {
          credentials: "same-origin",
          headers: { "Accept": "application/json" }
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        var data = await res.json();
        products = (data && data.products) ? data.products : [];
      }

      var available = products.filter(isAvailable);
      var picked = pickProducts(available, Math.max(1, limit));

      if (!picked.length) { el.innerHTML = ""; return; }

      var html = buildHead(collectionInfo, handle, targetBlank);
      html += '<div class="eiken-prodgrid__grid">';
      picked.forEach(function (p, i) { html += buildCard(p, targetBlank, pathPrefix, i); });
      html += "</div>";

      el.innerHTML = html;
      document.dispatchEvent(new CustomEvent("eiken:list-rendered", { detail: { el: el } }));
    } catch (e) {
      console.warn("[EIKEN prodgrid] fetch failed:", url, e);
      el.innerHTML = "";
    }
  }

  // Serialize loads so session dedup sees blocks picked by earlier blocks
  var loadQueue = Promise.resolve();
  function enqueueLoad(el) {
    loadQueue = loadQueue.then(function () {
      return loadOne(el).catch(function () {});
    });
  }

  // Mesure des clics (01/10/2026). On marque l'URL de la carte au moment de
  // l'interaction ; le page_view et le view_item de la fiche portent alors
  // page_location avec ces paramètres. Gardé tel quel pour la série commencée
  // le 01/10. Correction 02/10 : gtag EST appelable depuis le thème (le canal
  // Google le pose dans la page) ; les événements view_item_list / select_item
  // de ces cartes partent d'eiken-menu-events.js, qui lit les data-eg-*.
  //   eg_src=prodgrid  eg_col=<handle collection>  eg_blk=<n° du bloc>  eg_pos=<n° carte>
  //   lien « Voir tous » de l'en-tête : eg_src=prodgrid-collection, sans eg_pos.
  // Le href rendu reste propre (les robots ne cliquent pas) ; mousedown couvre
  // aussi clic du milieu et clic droit « ouvrir dans un onglet », touchstart
  // l'appui long mobile, click la touche Entrée.
  function tagCardLink(e) {
    var a = e.target && e.target.closest ? e.target.closest("a.eiken-card, a.eiken-prodgrid__all") : null;
    if (!a || a.getAttribute("data-eg-tagged")) return;
    var block = a.closest(".eiken-prodgrid");
    if (!block) return;
    try {
      var blocks = Array.prototype.slice.call(document.querySelectorAll(".eiken-prodgrid"));
      var isAll = a.classList.contains("eiken-prodgrid__all");
      var u = new URL(a.getAttribute("href"), window.location.href);
      u.searchParams.set("eg_src", isAll ? "prodgrid-collection" : "prodgrid");
      u.searchParams.set("eg_col", pickHandle(block));
      u.searchParams.set("eg_blk", String(blocks.indexOf(block) + 1));
      if (!isAll) u.searchParams.set("eg_pos", a.getAttribute("data-eg-pos") || "");
      a.setAttribute("href", u.pathname + u.search + u.hash);
      a.setAttribute("data-eg-tagged", "1");
    } catch (err) {}
  }

  function init() {
    var blocks = document.querySelectorAll(".eiken-prodgrid");
    if (!blocks.length) return;
    ["mousedown", "touchstart", "click"].forEach(function (type) {
      document.addEventListener(type, tagCardLink, { capture: true, passive: true });
    });
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            enqueueLoad(entry.target);
          }
        });
      }, { rootMargin: "900px 0px" }); // 200px avant : la grille arrivait sous les yeux
      blocks.forEach(function (el) { observer.observe(el); });
    } else {
      blocks.forEach(enqueueLoad);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
